"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var d3 = _interopRequireWildcard(require("d3"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function computeCentroid(points) {
  var xs = points.map(function (p) {
    return p.x;
  });
  var ys = points.map(function (p) {
    return p.y;
  });
  var sumX = xs.reduce(function (acc, v) {
    return acc + v;
  }, 0);
  var sumY = ys.reduce(function (acc, v) {
    return acc + v;
  }, 0);
  return {
    x: sumX / points.length,
    y: sumY / points.length
  };
}

var DataPolygon = function DataPolygon(_ref) {
  var theme = _ref.theme,
      inverted = _ref.inverted,
      primary = _ref.primary,
      scales = _ref.scales,
      data = _ref.data,
      show = _ref.show,
      sum = _ref.sum;
  if (!data) return null;
  var north = scales.north,
      east = scales.east,
      south = scales.south,
      west = scales.west; // Collect points

  var points = [];

  if (show.north) {
    var item = data.north;
    points.push({
      x: (east || west)(0),
      y: north(item.value),
      label: item.label,
      value: item.value
    });
  }

  if (show.east) {
    var _item = data.east;
    points.push({
      x: east(_item.value),
      y: (north || south)(0),
      label: _item.label,
      value: _item.value
    });
  }

  if (show.south) {
    var _item2 = data.south;
    points.push({
      x: (west || east)(0),
      y: south(_item2.value),
      label: _item2.label,
      value: _item2.value
    });
  }

  if (show.west) {
    var _item3 = data.west;
    points.push({
      x: west(_item3.value),
      y: (south || north)(0),
      label: _item3.label,
      value: _item3.value
    });
  } // Add dummy point if less than 2 points in order to have enough for a polygon to fill


  if (points.length < 3) {
    points.push({
      x: (east || west)(0),
      y: (north || south)(0),
      isDummy: true
    });
  }

  var sumTextElm;

  if (sum) {
    var centroid = computeCentroid(points);

    var _sum = points.map(function (p) {
      return p.value || 0;
    }).reduce(function (acc, v) {
      return acc + v;
    }, 0);

    if (_sum > 0) {
      sumTextElm = /*#__PURE__*/_react.default.createElement("text", {
        x: centroid.x,
        y: centroid.y,
        fill: theme.default,
        textAnchor: "middle",
        alignmentBaseline: "middle",
        fontFamily: theme.font2,
        fontSize: "30px",
        fontWeight: "300"
      }, Math.round(_sum * 100), "%");
    }
  } // Make polygon between points


  var polygonColor = inverted ? theme.inverted.one[0] : theme.one[0];
  if (primary) polygonColor = theme.color[1];
  var strokeColor = inverted ? theme.inverted.one[0] : theme.one[0];
  if (primary) strokeColor = theme.color[1];
  var firstPoint = points[0];
  var restPoints = points.slice(1, points.length);
  var path = d3.path();
  path.moveTo(firstPoint.x, firstPoint.y);
  restPoints.forEach(function (p) {
    return path.lineTo(p.x, p.y);
  });
  path.closePath();

  var pathElm = /*#__PURE__*/_react.default.createElement("path", {
    fill: polygonColor,
    fillOpacity: "0.2",
    stroke: polygonColor,
    strokeWidth: "2",
    d: path.toString()
  }); // Make circles at points


  var realPoints = points.filter(function (p) {
    return !p.isDummy;
  });
  var circleElm = realPoints.map(function (point, i) {
    return /*#__PURE__*/_react.default.createElement("circle", {
      key: i,
      cx: point.x,
      cy: point.y,
      r: "5",
      stroke: strokeColor,
      strokeWidth: 2,
      fill: inverted ? theme.inverted.two[0] : theme.two[0]
    });
  });
  return /*#__PURE__*/_react.default.createElement("g", null, pathElm, sumTextElm, /*#__PURE__*/_react.default.createElement("g", null, circleElm));
};

var dataItemPropType = _propTypes.default.shape({
  name: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired
});

DataPolygon.propTypes = {
  scales: _propTypes.default.shape({
    north: _propTypes.default.func.isRequired,
    east: _propTypes.default.func.isRequired,
    south: _propTypes.default.func.isRequired,
    west: _propTypes.default.func.isRequired
  }).isRequired,
  data: _propTypes.default.shape({
    north: dataItemPropType,
    east: dataItemPropType,
    south: dataItemPropType,
    west: dataItemPropType
  }).isRequired,
  show: _propTypes.default.shape({
    north: _propTypes.default.bool,
    east: _propTypes.default.bool,
    south: _propTypes.default.bool,
    west: _propTypes.default.bool
  }),
  sum: _propTypes.default.bool,
  primary: _propTypes.default.bool,
  inverted: _propTypes.default.bool
};
DataPolygon.defaultProps = {
  sum: false,
  primary: false,
  inverted: false,
  show: {
    north: true,
    east: true,
    south: true,
    west: true
  }
};

var _default = (0, _styledComponents.withTheme)(DataPolygon);

exports.default = _default;
//# sourceMappingURL=DataPolygon.js.map